import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 21,
  small: 14,
  xSmall: 11
};
const EmailIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25.5 7.5V22.5H4.5V7.5H25.5ZM6.34288 8.5L15 14.879L23.6571 8.5H6.34288ZM24.5 9.12108V21.5H5.5V9.12108L15 16.1211L24.5 9.12108Z",
        fill: "currentColor"
      }
    )
  );
};
EmailIcon.iconName = "EmailIcon";

export { EmailIcon };
